var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-code-mirror"},[_c('textarea',{ref:"codeEditor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }